var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isElectron && _vm.os === 'darwin')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.winStatus !== 'max'),expression:"winStatus !== 'max'"}],staticStyle:{"-webkit-app-region":"drag","width":"65px"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }